iScreenWizard.controller('HandleidingController', function ($scope, $state, $mdDialog, Ajax, Dictionary, Handleiding, userService) {

    $scope.handleidingen = [];
    $scope.user = userService.model;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.loadEmaillog();
    });

    $scope.loadEmaillog = function() {
        Handleiding.all().then(function (handleidingen) {
            $scope.handleidingen = handleidingen;
        });
    };

    $scope.viewHandleiding = function(handleiding, ev) {
        $mdDialog.show({
            controller: HandleidingDialogController,
            locals: {
                handleiding: handleiding
            },
            templateUrl: '/info/handleidingen/show',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true
        });
    };

    function HandleidingDialogController($scope, handleiding) {
        $scope.handleiding = handleiding;
    };

});